/* eslint-disable  */
import React, { useEffect, useState } from "react";
import RenderAdminPage from "../RenderAdminPage";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { dataActionCreators } from "../../services/Actions";
import { bindActionCreators } from "redux";
import CediSymbol from "../../Components/CediSymbol";
import Loader from "../../Components/Loader";
import { useHistory } from "react-router-dom";
import { SiMicrosoftexcel } from "react-icons/si";
import { toast } from "react-toastify";
function FundIncrement() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { GetFundIncrement, DownloadFundIncrement } = bindActionCreators(
    dataActionCreators,
    dispatch
  );
  const [limit, setLimit] = useState(20);
  const [formData, setFormData] = useState({});

  const [search, setSearch] = useState(null);

  const handleLimit = (e) => {
    setLimit(e.target.value);
  };
  const data = useSelector((state) => state.data);
  // const paginate = data?.paginate
  const { fund_increment, isLoading } = data;

  useEffect(() => {
    GetFundIncrement();
  }, []);

  console.log("fund_increment", fund_increment);

  const onSearchTextChange = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
      console.log("search", search);
      console.log("e?.target?.value", e?.target?.value);
      //   GetAllFunds(
      //     true,
      //     1,
      //     15,
      //     `${e?.target?.value ? "&search=" + e?.target?.value : ""}`
      //   );
    } else {
      setSearch(null);
      //   GetAllFunds(true, 1, 15, null);
    }
  }, 800);

  const hanndleDate = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const downloadExcelData = async (data) => {
    // await axiosInstance.get('/funds/download').then((res) => res.data)
    // fetch('http://localhost:8000/api/v1/funds/download').then(res => {res.blob(); console.log('res.blob', res.blob())} ).then(blob => {
    //   const url = window.URL.createObjectURL(new Blob([blob]))
    //   console.log('blob', blob)
    //   const link = document.createElement('a')
    //   link.href = url
    //   link.setAttribute('download', 'funds.xlsx')
    //   document.body.appendChild(link)
    //   link.click()
    //   document.body.removeChild(link)
    // })

    if (formData.fromDate == "" && formData.endDate == "") {
      toast.error("Please select start and end date");
    } else {
      // console.log('formData', formData)
      DownloadFundIncrement(formData);
    }
  };
  return (
    <div>
      <RenderAdminPage title="Fund Increment">
        {isLoading && <Loader />}

        <div className="flex flex-col sm:flex-row items-start sm:items-end gap-3 mb-6">
          <div className="flex items-center gap-3">
            <div>
              <label htmlFor="startDate" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Start Date</label>
              <input
                type="date"
                onChange={hanndleDate}
                name="startDate"
                id="startDate"
                className="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              />
            </div>
            <div>
              <label htmlFor="endDate" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">End Date</label>
              <input
                type="date"
                onChange={hanndleDate}
                name="endDate"
                id="endDate"
                className="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              />
            </div>
            <button
              onClick={downloadExcelData}
              className="mt-6 p-2.5 rounded-xl bg-green-600 hover:bg-green-700 text-white transition-colors"
              title="Download Excel"
            >
              <SiMicrosoftexcel size={20} />
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center mb-4">
          <p className="text-sm text-slate-500 dark:text-slate-400">{fund_increment?.length || 0} records</p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 dark:bg-gray-700/50">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Member Info</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Current Contribution</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Requested Amount</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Phone Number</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Facility</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                {fund_increment?.length > 0 ? (
                  <>
                    {fund_increment?.map((fund, index) => (
                      <tr key={index + 1} className="hover:bg-slate-50 dark:hover:bg-gray-700/30 transition-colors">
                        <td className="px-4 py-3">
                          <div>
                            <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{fund?.name}</p>
                            <p className="text-xs text-slate-500 dark:text-slate-400 font-semibold">{fund?.staff_id}</p>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300"><CediSymbol />{fund?.current_contribution}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{fund?.requested_increment}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{fund?.phone_number}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{fund?.facility}</td>
                        <td className="px-4 py-3 text-right">
                          <button
                            type="button"
                            onClick={() => history.push("/admin/fund-increment-detailed", { state: fund })}
                            className="text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                          >
                            <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24"><path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" /></svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr><td colSpan="6" className="px-4 py-12 text-center text-sm text-slate-400 dark:text-slate-500">No data available</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </RenderAdminPage>
    </div>
  );
}

export default FundIncrement;
